import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'product';

export default {
  async search(queryParams) {
    const url = mountUrl(`/${BASE_PATH}`, queryParams);
    return api.get(url);
  },
  async create(data) {
    const url = mountUrl(`/${BASE_PATH}`);
    return api.post(url, data);
  },
  async update(productId, data) {
    const url = mountUrl(`/${BASE_PATH}/${productId}`);
    return api.patch(url, data);
  },
  async inactivate(productId) {
    const url = mountUrl(`/${BASE_PATH}/${productId}`);
    return api.delete(url);
  }
};
